import { Box } from '@mui/material';

import { MentionInputComposable } from './MentionInputComposable';
import { MentionInputProvider } from './MentionInputContext';
import type { MentionInputConfigurableProps } from './types';

export function MentionInputConfigurable({
  entityId,
  sourceProduct,
  sourceRecordUrn,
  sourceContextType,
  sourceContextId,
  deepLinkUrl,
  notificationTargetDisplay,
  onMentionCreated,
  onMentionError,
  placeholder,
  disabled,
  maxMentionsPerComment,
  sx,
}: MentionInputConfigurableProps) {
  return (
    <Box {...(sx != null ? { sx } : {})}>
      <MentionInputProvider
        entityId={entityId}
        sourceProduct={sourceProduct}
        sourceRecordUrn={sourceRecordUrn}
        sourceContextType={sourceContextType}
        sourceContextId={sourceContextId}
        deepLinkUrl={deepLinkUrl}
        notificationTargetDisplay={notificationTargetDisplay}
        maxMentionsPerComment={maxMentionsPerComment}
        onMentionCreated={onMentionCreated}
        onMentionError={onMentionError}
      >
        <MentionInputComposable.Editor placeholder={placeholder} disabled={disabled} />
        <MentionInputComposable.PermissionWarning />
      </MentionInputProvider>
    </Box>
  );
}
